export const RESOURCE_TYPES = [
  { value: 'data_engineer', label: 'Data Engineer', defaultRate: 3000 },
  { value: 'consultant', label: 'Consultant', defaultRate: 3500 },
  { value: 'data_analyst', label: 'Data Analyst', defaultRate: 2500 },
  { value: 'project_manager', label: 'Project Manager', defaultRate: 2800 },
  { value: 'data_scientist', label: 'Data Scientist', defaultRate: 3200 },
  { value: 'qa_testing', label: 'QA/Testing', defaultRate: 2200 },
  { value: 'data_architect', label: 'Data Architect', defaultRate: 3400 },
  { value: 'frontend_dev', label: 'Front End Developer', defaultRate: 2800 },
  { value: 'backend_dev', label: 'Back End Developer', defaultRate: 3000 },
  { value: 'fullstack_dev', label: 'Full-Stack Developer', defaultRate: 3200 },
];

export const PROJECT_TYPES = [
  { value: 'staff_aug', label: 'Staff Aug' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'ops_support', label: 'Ops Support' },
];

export const CATEGORIES = [
  { value: 'regular', label: 'Regular' },
  { value: 'pass_thru', label: 'Pass-thru' },
];

export const PROJECT_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'proposal', label: 'Proposal' },
  { value: 'sow', label: 'SoW' },
  { value: 'execute', label: 'Execute' },
  { value: 'closed', label: 'Closed' },
];

export const INVOICE_STATUSES = [
  { value: 'po_awaited', label: 'PO Awaited' },
  { value: 'to_be_invoiced', label: 'To Be Invoiced' },
  { value: 'invoiced', label: 'Invoiced' },
];

export const STATUS_COLORS = {
  draft: 'text-zinc-400 bg-zinc-400/10 border-zinc-400/20',
  proposal: 'text-brand-400 bg-brand-400/10 border-brand-400/20',
  sow: 'text-blue-400 bg-blue-400/10 border-blue-400/20',
  execute: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  closed: 'text-violet-400 bg-violet-400/10 border-violet-400/20',
};

export const INVOICE_STATUS_COLORS = {
  po_awaited: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
  to_be_invoiced: 'text-brand-400 bg-brand-400/10 border-brand-400/20',
  invoiced: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
};
